export function getListId(environment) {
  const env = environment || process.env.REACT_APP_ENV || process.env.NODE_ENV;
  return env === 'production' ? 200001 : 101010;
}
